import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  ResolveFn,
  RouterStateSnapshot,
} from '@angular/router';
import { CategoriesService } from '../home/categories/services/categories.service';
import { Categories } from '../home/models/categories.interface';
import { catchError, from, of } from 'rxjs';

export const CategoryResolverService: ResolveFn<Categories[]> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  return from(inject(CategoriesService).getCategories()).pipe(
    catchError(error => {
      console.error(error);
      return of([]);
    })
  );
};
